<template>
  <div>
    <div class="l-container">
      <router-view :user="user"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    user () {
      return this.$store.getters.user
    }
  },
  data () {
    return {
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getUser(to.params.id)
    })
  },
  methods: {
    getUser (id) {
      this.$store.dispatch('getUser', id)
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// User.vue?1b10bc90